import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/screens/brief/utils/briefTrackerCreatedToast";
import { OspToast } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

/** Tracker 创建成功 Snackbar：文案 + View 跳转 Desk 详情 */
export const showBriefTrackerCreatedToast = (onView: () => void): void => {
  OspToast.success({
    content: I18n.t("New tracker created. Ed will post updates on Desk."),
    action: {
      label: I18n.t("View"),
      onClick: onView,
    },
    key: "brief-tracker-created",
    duration: 5,
  });
};

/** Tracker 创建失败 */
export const showBriefCreateNoteFailedToast = (): void => {
  OspToast.error({
    content: I18n.t("Couldn't create note. Try again."),
    key: "brief-create-note-failed",
  });
};

/** Tracker 草稿拉取失败 */
export const showBriefDraftFailedToast = (): void => {
  OspToast.info({
    content: I18n.t("Ed is working on it..."),
    key: "brief-draft-failed",
  });
};
